import { useFormContext, useWatch, UseFormProps, UseFormReturn } from "react-hook-form";

import Linkify from 'linkify-react'

import { Box, Card, CardContent, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'

import { TextInput } from "../components/TextInput";

export interface IFamilyFormProps {
  title: string
  subtitle?: string
  schoolName3: string
}


export const FamilyForm = (props: IFamilyFormProps) => {

  const form: UseFormReturn<IFamilyFormProps, UseFormProps> = useFormContext();

  return (
    <Box sx={{ minWidth: 275, mt: 1 }}>
      <Card variant="outlined" sx={{ backgroundColor: '#EAF2F1', borderRadius: .6  }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ ml: 3 }}>{props.title}</Typography>
          <Typography variant="body2" gutterBottom sx={{ ml: 3 }}>{`${props.subtitle} í ${props.schoolName3}`}</Typography>
          <Grid container spacing={1}>

            <Grid xs={12}>
              <TextInput multiline={true} name="familyText" />
            </Grid>

          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}